import Call from '../Call';
import {objToQs} from '../Utils';

const PayoutFactor = {
    get(filters) {
        return Call(`payoutFactor?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`payoutFactor/affid`);
    },

    getAll(filters) {
        return Call(`payoutFactor/all?${objToQs(filters)}`);
    },

    getSubids(filters) {
        return Call(`payoutFactor/subid?${objToQs(filters)}`);
    },

    getSubidsAll(filters) {
        return Call(`payoutFactor/subid/all?${objToQs(filters)}`);
    },

    updateFactor(affid, subid, country, factor) {
        return Call(`payoutFactor/factor`, 'PUT', { affid, subid, country, factor })
    }
}

export default PayoutFactor;


// WEBPACK FOOTER //
// ./src/services/API/components/PayoutFactor.js